import { render, staticRenderFns } from "./OrganismBuildingErrorOccurred.vue?vue&type=template&id=0ef824d5&scoped=true&"
import script from "./OrganismBuildingErrorOccurred.vue?vue&type=script&lang=js&"
export * from "./OrganismBuildingErrorOccurred.vue?vue&type=script&lang=js&"
import style0 from "./OrganismBuildingErrorOccurred.vue?vue&type=style&index=0&id=0ef824d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef824d5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomLoadingError: require('/app/components/atoms/common/AtomLoadingError.vue').default})
